import { useMemo } from 'react';

import type { AutocompleteResponse } from '../../../search/models/models';

export const useAutocomplete = (
    initialQuery?: string,
    autoCompleteResult?: AutocompleteResponse,
    queryUsed: string | undefined = undefined,
) => {
    const autocompleteQuery = initialQuery || autoCompleteResult?.query;

    // remove hints that are the same as query
    const filteredHints = useMemo(
        () =>
            autoCompleteResult?.hints?.filter(
                (hint) =>
                    hint.toLowerCase() !== autocompleteQuery?.toLowerCase() &&
                    hint.toLowerCase() !== queryUsed?.toLowerCase(),
            ) || [],
        [autoCompleteResult, autocompleteQuery, queryUsed],
    );

    return {
        hints: filteredHints,
        autocompleteQuery,
    };
};
